import NextImage from 'next/image';

import React from 'react';
import Balancer from 'react-wrap-balancer';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';
import { Link } from '@components/parts/Link';

import { LinkProps } from '@customTypes/Link';
import { TDIs } from '@customTypes/TDI';

type Props = {
  backgroundColor?: string;
  cardBackgroundColor?: string;
  color?: string;
  tdis: TDIs;
  forceColumn?: boolean;
  noContainer?: boolean;
  action?: LinkProps;
};

const Wrapper = styled.div<Props>`
  padding-top: 25px;
  padding-bottom: 90px;

  .link {
    padding-top: 2.2em;
  }
  .cards {
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      flex-direction: row;
      ${(props) => (props.forceColumn ? 'flex-direction: column;' : '')}
    }

    .card {
      ${(props) => (props.cardBackgroundColor ? `background-color: ${props.cardBackgroundColor}; padding: 1.6em;` : '')}
      display: flex;
      flex-direction: row;
      gap: 20px;
      margin-top: 50px;
      @media (min-width: 992px) {
        flex-direction: column;
        margin-top: 45px;
      }
      .icon {
        img {
          width: 30px;
          height: 30px;
          @media (min-width: 992px) {
            width: 40px;
            height: 40px;
          }
        }
      }
      flex: 1;
      .title {
        margin-bottom: 0.3em;
        @media (min-width: 992px) {
          margin-top: 0.2em;
        }
      }
      .description {
        opacity: 0.8;
        margin-bottom: 1em;
        color: #a3a7ae;
        @media (min-width: 992px) {
          margin-bottom: 0;
        }
      }
    }
  }
`;

const Div = styled.div``;

export const IconTDIs: React.FC<Props> = (props) => {
  const { backgroundColor, color, tdis, action, noContainer } = props;
  const HC = noContainer ? Div : Container;
  return (
    <div className="IconTDIs" style={{ backgroundColor: backgroundColor ?? '#172030', color: color ?? '#E3E5EA' }}>
      <HC>
        <Wrapper {...props}>
          <div className="cards">
            {tdis.map((tdi, idx) => (
              <ScrollReveal key={`${idx}`} className="card" intervalDelay={idx * 300}>
                {tdi.image?.data?.attributes?.url ? (
                  <div className="icon">
                    <NextImage src={tdi.image.data.attributes.url} alt={tdi.title} width={40} height={40} />
                  </div>
                ) : null}
                <div className="td">
                  <h5 className="title">
                    <Balancer>{tdi.title}</Balancer>
                  </h5>
                  <div className="description">
                    <Balancer>{tdi.description}</Balancer>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
          {action ? <Link {...action} /> : null}
        </Wrapper>
      </HC>
    </div>
  );
};
